import { createAction } from 'Lib/reduxUtils';

export const FILTER_ENTITY_IDS = 'FILTER_ENTITY_IDS';

export const filterEntityIds = createAction(FILTER_ENTITY_IDS, (typeOrEntityFilterIds, ids) => {
  const entityFilterIds =
    typeof typeOrEntityFilterIds === 'object'
      ? typeOrEntityFilterIds
      : { [typeOrEntityFilterIds]: ids };
  return { entityFilterIds };
});
